'use client'

import {
	addDefaultVisibleValuesToMenuContent,
	TMenuContent,
} from 'features/generator/contentFormSections/MenuForm/MenuForm'
import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { menuContentAtom } from './MenuContentState'
import { MenuScreen } from './MenuScreen'

export const MenuLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TMenuContent
}) => {
	// Add default visible values for backward compatibility with old QR codes
	const processedContent = addDefaultVisibleValuesToMenuContent(content)

	useHydrateAtoms([
		[qrUriAtom, uri],
		[menuContentAtom, processedContent],
	])

	return <MenuScreen previewMode={false} demoMode={false} />
}
